/**
 * TODO: после задачи https://youtrack.mamba.ru/issue/M-9909 удалить и использовать только voteable оставить только voteable
 * @deprecated
 * */
export const isVoteable = (
  place: 'profile' | 'rating' | null,
  voteable?: boolean
) =>
  place &&
  voteable !== undefined &&
  ((place === 'profile' && voteable) || place === 'rating')
